// lib/slides/westfieldGuidelines.ts
import type { SlidesGuidelineKey } from '#types/types';
//
// Canonical pointer to the Westfield / URW RDM guidelines PDF. The binding
// agentic context that references it lives in the EDITABLE Slides doctrine
// (lib/slidesDoctrineTemplate.ts -> Doctrine tab, TOOL/SLIDES scope), so what the
// agent follows is visible and refinable there rather than hidden in the prompt
// code. This module only owns the source-of-truth URL + label the doctrine cites.

/**
 * Canonical Westfield / URW RDM guidelines PDF. Hosted permanently and public in
 * the `public-project-assets` container. Update here to re-point every citation.
 */
export const WESTFIELD_GUIDELINES_PDF_URL =
  'https://app.fater.ai/api/assets/public-project-assets/doctrine/westfield-rdm-guidelines-inline-units-2026.pdf';

/** Human label for the guidelines document, used in the doctrine + UI. */
export const WESTFIELD_GUIDELINES_LABEL = 'RDM Guidelines: Westfield / URW (Inline Units 2026)';

/** The guideline sets a deck can be reviewed against, in display order. */
export const SLIDES_GUIDELINES: ReadonlyArray<{ key: SlidesGuidelineKey; label: string }> = [
  { key: 'inline_unit', label: 'Inline unit' },
  { key: 'kiosk', label: 'Kiosk' },
  { key: 'food_unit', label: 'Food unit' },
];

export const guidelineLabel = (key: SlidesGuidelineKey): string =>
  SLIDES_GUIDELINES.find((g) => g.key === key)?.label ?? key;
